import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react"
import { MainPage } from "../../App"
import { URLForwardSlashSeparator } from "../../common/commonConstants"
import { isTruthy } from "./utils"

export interface breadCrumbsInterface {
  firstLevel?: {
    title: string
    path: string
  }
  secondLevel?: {
    title: string
    path: string
  }
  thirdLevel?: {
    title: string
    path?: string
  }
  fourthLevel?: {
    title: string
    path?: string
  }
}

export const BreadCrumb = ({ options }: { options: breadCrumbsInterface }): JSX.Element => {
  const firstLevel = options?.firstLevel ?? null
  const secondLevel = options?.secondLevel ?? null
  const thirdLevel = options?.thirdLevel ?? null
  const fourthLevel = options?.fourthLevel ?? null

  return (
    <MainPage>
      {isTruthy(options) && (
        <Breadcrumb
          mt={"14px"}
          mr={["0", "0", "0", "26px", "26px", "26px"]}
          px={[4, 4, 4, 0]}
          fontFamily={"PT Sans"}
          w="100%"
          fontSize="12px"
          color="primary"
          lineHeight={"18px"}
          fontWeight={"400"}
          spacing="3px"
          boxSize={"border-box"}
        >
          {firstLevel && (
            <BreadcrumbItem>
              <BreadcrumbLink href={`${firstLevel.path}`}>{firstLevel.title}</BreadcrumbLink>
            </BreadcrumbItem>
          )}

          {secondLevel && (
            <BreadcrumbItem>
              <BreadcrumbLink href={`${secondLevel.path}`}>{secondLevel.title}</BreadcrumbLink>
            </BreadcrumbItem>
          )}
          {thirdLevel && (
            <BreadcrumbItem>
              <BreadcrumbLink
                href={fourthLevel?.title !== "" ? thirdLevel.path : ""}
                fontWeight={fourthLevel ? "400" : "700"}
                ml={["2px", "2px", "0px"]}
              >
                {thirdLevel.title}
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}
          {fourthLevel && (
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink href="#" fontWeight="700" ml={["2px", "2px", "0px"]}>
                {/* // Replace | with / in the product code to send to the server. A correction to | was made so that the URL doesn't contain /. */}
                {fourthLevel.title.replaceAll(URLForwardSlashSeparator, "/")}
              </BreadcrumbLink>
            </BreadcrumbItem>
          )}
        </Breadcrumb>
      )}
    </MainPage>
  )
}
